import { render, staticRenderFns } from "./PageHeadline.vue?vue&type=template&id=873d9250&scoped=true&"
import script from "./PageHeadline.vue?vue&type=script&lang=js&"
export * from "./PageHeadline.vue?vue&type=script&lang=js&"
import style0 from "./PageHeadline.vue?vue&type=style&index=0&id=873d9250&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "873d9250",
  null
  
)

export default component.exports